"use client";

import Link from "next/link";
import getLegacySitePath from "@/app/util/getLegacySitePath";
import {useCookieCampusId} from "@/app/_components/contexts/CampusCookieContext";

const StaffConsultationFormLink = () => {
	const campusId = useCookieCampusId();
	const staffFormHref = getLegacySitePath("/consultation/schedule", campusId);
	return (
		<Link className="text-xl text-hyperlink" href={staffFormHref}>
			&gt; Go to staff consultation form (staff only)
		</Link>
	);
};

export default StaffConsultationFormLink;
